var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "border-work-wrapper" },
    [
      _c("h3", { attrs: { "data-aos": "fade-left" } }, [
        _vm._v(_vm._s(_vm.$t("ac_cleaning.question_section.title")))
      ]),
      _vm._v(" "),
      _vm._l(_vm.questions, function(q, index) {
        return _c("div", { key: index, staticClass: "question-item" }, [
          _c(
            "div",
            {
              staticClass: "question-header",
              class: { active: _vm.questionIndex === index },
              on: {
                click: function($event) {
                  return _vm.setQuesionIndex(index)
                }
              }
            },
            [
              _c("p", { staticClass: "list" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t(
                        "ac_cleaning.question_section.questions." +
                          index +
                          ".question"
                      )
                    ) +
                    "\n    "
                )
              ]),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src:
                    _vm.questionIndex === index ? _vm.minusIcon : _vm.plusIcon,
                  alt: "toggle"
                }
              })
            ]
          ),
          _vm._v(" "),
          q.contents.length > 0 && _vm.questionIndex === index
            ? _c(
                "ul",
                { staticClass: "list-unstyled question-content" },
                _vm._l(q.contents, function(content, cIndex) {
                  return _c("li", {
                    key: cIndex,
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t(
                          "ac_cleaning.question_section.questions." +
                            index +
                            ".answer." +
                            cIndex
                        )
                      )
                    }
                  })
                }),
                0
              )
            : _vm._e()
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2488873c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2488873c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acCleaningRe/Questions.vue
// module id = 1612
// module chunks = 0